var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLearnMoreIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 21.75H15.75",
    stroke: "#80FF00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18.75V13.5",
    stroke: "#80FF00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 10.5L12 13.5L15 10.5",
    stroke: "#80FF00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.3782 15.6564C6.48532 14.9621 5.76216 14.0738 5.26351 13.0586C4.76485 12.0434 4.50378 10.9281 4.50008 9.79703C4.48133 5.72828 7.7532 2.3439 11.822 2.25015C13.3966 2.21283 14.9431 2.67222 16.242 3.56318C17.541 4.45415 18.5264 5.73146 19.0586 7.21395C19.5908 8.69644 19.6428 10.3089 19.2071 11.8225C18.7714 13.3362 17.8702 14.6743 16.6313 15.647C16.3577 15.8586 16.136 16.1299 15.9832 16.4402C15.8305 16.7506 15.7507 17.0918 15.7501 17.4377V18.0002C15.7501 18.1991 15.6711 18.3898 15.5304 18.5305C15.3898 18.6711 15.199 18.7502 15.0001 18.7502H9.00008C8.80117 18.7502 8.6104 18.6711 8.46975 18.5305C8.3291 18.3898 8.25008 18.1991 8.25008 18.0002V17.4377C8.24773 17.0944 8.16814 16.756 8.01721 16.4476C7.86628 16.1393 7.64788 15.8689 7.3782 15.6564V15.6564Z",
    stroke: "#80FF00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearnMoreIcon);
export default __webpack_public_path__ + "static/media/LearnMoreIcon.bfaec9ca661743089b1fe9e9cff22672.svg";
export { ForwardRef as ReactComponent };